import { render } from "./PunchSystem.vue?vue&type=template&id=d5940be4&scoped=true"
import script from "./PunchSystem.vue?vue&type=script&lang=js"
export * from "./PunchSystem.vue?vue&type=script&lang=js"

import "./PunchSystem.vue?vue&type=style&index=0&id=d5940be4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5940be4"]])

export default __exports__